import { restCommon } from 'live/lib/utils'

export interface UserListParams {
    diffOnly: boolean
    enabled: boolean
    dir: number
    page: number
    pageSize: number
    sort: string
    query: string
}

export interface LiveUser {
    id: number
    name: string
    username: string
    email: string
}

export const listUser = async (params?: Partial<UserListParams>): Promise<LiveUser[]> => {
    const qs = new URLSearchParams({
        diffOnly: String(params?.diffOnly ?? false),
        enabled: String(params?.enabled ?? true),
        dir: String(params?.dir ?? 1),
        page: String(params?.page ?? 1),
        pageSize: String(params?.pageSize ?? 9999),
        sort: params?.sort ?? 'name',
        query: params?.query ?? ''
    }).toString()

    return fetch(`/rest/user?${qs}`, {
        ...restCommon,
        method: 'GET'
    }).then(async data => {
        let jsonData

        try {
            jsonData = await data.json()
        } catch (err) {
            jsonData = undefined
        }

        if (data.ok) {
            return jsonData.data
        } else {
            throw new Error(jsonData?.Message ?? jsonData?.error ?? jsonData?.message ?? jsonData?.message)
        }
    })
}
